import React, { forwardRef } from "react";

import {
  Slide,
  Radio,
  AppBar,
  Dialog,
  Select,
  Avatar,
  Divider,
  Toolbar,
  MenuItem,
  Skeleton,
  FormLabel,
  TextField,
  IconButton,
  InputLabel,
  Typography,
  RadioGroup,
  FormControl,
  FormHelperText,
  FormControlLabel,
} from "@mui/material";
import { LoadingButton } from "@mui/lab";
import CloseIcon from "@mui/icons-material/Close";

import {
  getAcronym,
  getFullName,
  isEmpty as isStringEmpty,
} from "../../../../utils/string";
import { isEmpty as isArrayEmpty } from "../../../../utils/array";

import Job from "../../assets/images/job.png";
import Location from "../../assets/images/location.png";

import { DIRECTED_AT } from "../../constants/constants";

import "./RecognitionDialog.css";

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function RecognitionDialog({
  open,
  onClose,
  onSubmit,
  directedAt,
  isSubmitting,
  formData = {},
  categories = [],
  isLoadingDirectedAt,
  isFetchingCategories,
  hasTriedFormSubmission,
  changeFormData = () => {},
}) {
  return (
    <Dialog
      fullScreen
      open={open}
      onClose={onClose}
      TransitionComponent={Transition}
    >
      <AppBar
        sx={{
          position: "sticky",
          borderBottom: "1px solid rgba(0,0,0,0.15)",
        }}
        color="inherit"
        elevation={0}
      >
        <Toolbar
          sx={{
            padding: "16px 24px",
          }}
        >
          <IconButton
            edge="start"
            color="inherit"
            onClick={onClose}
            aria-label="close"
          >
            <CloseIcon />
          </IconButton>
          <Typography sx={{ ml: 1, flex: 1 }} variant="h6" component="div">
            Recognition
          </Typography>
          <LoadingButton
            size="large"
            onClick={onSubmit}
            variant="contained"
            loading={isLoadingDirectedAt || isSubmitting}
            disabled={isLoadingDirectedAt || isSubmitting}
          >
            Submit
          </LoadingButton>
        </Toolbar>
      </AppBar>

      <div className="recognition-content-wrapper">
        <div className="directed-at-wrapper">
          {isLoadingDirectedAt ? (
            <Skeleton variant="rounded" width="100%" height="67px" />
          ) : (
            <>
              <div className="left">
                <Avatar
                  src={directedAt?.caregiver?.profile_picture_url}
                  sx={{
                    width: 64,
                    height: 64,
                    fontSize: "28px",
                    bgcolor: "rgb(90,156,213)",
                  }}
                >
                  {getAcronym(
                    getFullName(
                      directedAt?.caregiver?.first_name,
                      directedAt?.caregiver?.last_name
                    )
                  )}
                </Avatar>
              </div>
              <div className="right">
                <div className="name-wrapper">
                  <h1>
                    {isStringEmpty(
                      getFullName(
                        directedAt?.caregiver?.first_name,
                        directedAt?.caregiver?.last_name
                      )
                    )
                      ? "..."
                      : getFullName(
                          directedAt?.caregiver?.first_name,
                          directedAt?.caregiver?.last_name
                        )}
                  </h1>
                </div>
                <div className="info-wrapper">
                  <div className="info">
                    <img src={Job} alt="Job" />
                    <span>
                      {!isStringEmpty(directedAt?.job?.job_title)
                        ? directedAt?.job?.job_title
                        : "-"}
                    </span>
                  </div>
                  <Divider orientation="vertical" sx={{ height: "14px" }} />
                  <div className="info">
                    <img src={Location} alt="Location" />
                    <span>
                      {!isStringEmpty(directedAt?.office_location)
                        ? directedAt?.office_location
                        : "-"}
                    </span>
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
        <Divider />
        <div className="form-wrapper">
          <div className="form-row">
            <div className="form-column">
              <FormControl>
                <InputLabel id="direct-at-select-helper-label">
                  Directed At *
                </InputLabel>
                <Select
                  required
                  disabled
                  labelId="direct-at-select-helper-label"
                  id="state-select"
                  value={formData?.directedAt}
                  label="Directed At *"
                  sx={{ width: "100%" }}
                >
                  {Object.keys(DIRECTED_AT)?.map((key) => (
                    <MenuItem
                      value={DIRECTED_AT[key]?.value}
                      key={DIRECTED_AT[key]?.id}
                    >
                      {DIRECTED_AT[key]?.label}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </div>
          </div>

          <div className="form-row category">
            <div className="form-column">
              {isFetchingCategories ? (
                <Skeleton variant="rounded" width="100%" height="180px" />
              ) : (
                <FormControl>
                  <FormLabel
                    id="demo-radio-buttons-group-label"
                    sx={{
                      marginBottom: 2,
                    }}
                  >
                    Category *
                  </FormLabel>
                  <RadioGroup
                    aria-labelledby="demo-radio-buttons-group-label"
                    value={formData?.category}
                    name="radio-buttons-group"
                    onChange={(event) =>
                      changeFormData("category", event?.target?.value)
                    }
                  >
                    {!isArrayEmpty(categories) &&
                      categories?.map((category) => (
                        <FormControlLabel
                          value={category}
                          control={<Radio />}
                          label={category}
                        />
                      ))}
                  </RadioGroup>
                  {hasTriedFormSubmission &&
                  isStringEmpty(formData?.category) ? (
                    <FormHelperText error>Category is required.</FormHelperText>
                  ) : (
                    ""
                  )}
                </FormControl>
              )}
            </div>
          </div>

          <div className="form-row">
            <div className="form-column">
              <TextField
                required
                id="outlined-multiline-static"
                label="Reason"
                multiline
                rows={8}
                value={formData?.reason}
                onChange={(event) =>
                  changeFormData("reason", event?.target?.value)
                }
                helperText={
                  hasTriedFormSubmission && isStringEmpty(formData?.reason)
                    ? "Reason is required."
                    : ""
                }
                error={
                  hasTriedFormSubmission && isStringEmpty(formData?.reason)
                }
              />
            </div>
          </div>
        </div>
      </div>
    </Dialog>
  );
}
